import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { Box, List, ListItemButton, Typography, Grid, ListItem } from "@mui/material";
import { FaArrowRight } from "react-icons/fa6";
import { isExternalLink } from "../../utils/utils";
import { getDataFromCmsApi } from "../../api/contentful-service";

const DivisionMoreServices = ({ collectionName }) => {
  const [servicesList, setServicesList] = useState();

  useEffect(() => {
    getServices();
  }, []);

  const getServices = async () => {
    const result = await getDataFromCmsApi(`Collection/${collectionName}`);
    setServicesList(result);
  };

  return (
    servicesList && (
      <Box className="pt-4 pb-5">
        <Typography variant="h3" className="pb-3 px-3 px-md-0 text-center text-md-start">
          More Services
        </Typography>

        <Grid container columnSpacing={12} rowSpacing={6} className="px-3 px-lg-0">
          {servicesList.items && servicesList.items.length > 0 && (
            <>
              {!servicesList.items[0].items ? (
                // If services.items is a list of single items
                <Grid item sm={12} className="w-100">
                  <List>
                    {servicesList.items.map((link, i) => (
                      <ListItem disablePadding><ListItemButton
                        key={i}
                        className="d-flex justify-content-between"
                        divider
                        component={Link}
                        to={link.link}
                        target={isExternalLink(link.link) ? "_blank" : ""}
                        rel={isExternalLink(link.link) ? "noopener noreferrer" : ""}
                      >
                        {link.serviceLabel}
                        <FaArrowRight />
                      </ListItemButton>
                      </ListItem>
                    ))}
                  </List>
                </Grid>
              ) : (
                servicesList.items.map((item, index) => (
                  <Grid key={index} item sm={12} md={6} lg={4} className="w-100">

                    <div
                      className="d-flex column-gap-2 justify-content-center align-items-center pb-1 mb-2"
                      style={{ borderBottom: `3px solid #003366`, color: "#003366" }}
                    >
                      <span className="fw-bold fs-5">{item.displayName}</span>
                    </div>
                    <List> {item.items &&
                      item.items.length > 0 &&
                      item.items.map((subItem, i) => (
                        <ListItem disablePadding> <ListItemButton
                          key={i}
                          className="d-flex justify-content-between"
                          divider
                          component={Link}
                          to={subItem.link}
                          target={isExternalLink(subItem.link) ? "_blank" : ""}
                          rel={isExternalLink(subItem.link) ? "noopener noreferrer" : ""}
                        >
                          {subItem.serviceLabel}
                          <FaArrowRight />
                        </ListItemButton></ListItem>
                      ))}
                    </List>
                  </Grid>
                ))
              )}
            </>
          )}
        </Grid>
      </Box>
    )
  );
};

DivisionMoreServices.propTypes = {
  collectionName: PropTypes.string.isRequired
};

export default DivisionMoreServices;
